import { useContext } from "react";
import { FeedContext } from "./context";
import { FeedContextValue } from "./types";

export const useFeedContext = (): FeedContextValue => {
  const context = useContext(FeedContext);
  if (context === undefined) {
    throw new Error("useFeedContext must be used within a FeedProvider");
  }
  return context;
};
